import Animated from 'react-native-reanimated'
import styled, { css } from 'styled-components/native'
import Typography from 'APP/Converse/Typography'
import { ToastVariant } from 'APP/Store/Toast/types'

const getBackgroundColor = (theme: any, variant?: ToastVariant) => {
  switch (variant) {
    case 'primary':
      return theme.colors.primary
    case 'error':
      return theme.colors.error
    case 'success':
    default:
      return theme.colors.success
  }
}

const getTextColor = (theme: any, variant?: ToastVariant) => {
  switch (variant) {
    case 'primary':
      return theme.colors.primaryText
    case 'error':
    case 'success':
    default:
      return theme.colors.darkText
  }
}

export const ToastContainer = styled(Animated.View)<{
  variant?: ToastVariant
  isWeb?: boolean
  hideMenuWebMargin?: boolean
}>`
  position: ${({ isWeb }) => (isWeb ? 'fixed' : 'absolute')};
  top: ${({ isWeb }) => (isWeb ? `20px` : `60px`)};
  ${({ isWeb, theme, hideMenuWebMargin = false }) => {
    if (!isWeb) {
      return css`
        left: ${theme.metrics.baseMargin}px;
        right: ${theme.metrics.baseMargin}px;
      `
    }
    const leftOffset = hideMenuWebMargin
      ? theme.metrics.baseMargin
      : theme.metrics.web.sidebarWidth + theme.metrics.baseMargin

    return css`
      ${theme.isSmallScreen
        ? css`
            left: ${theme.metrics.baseMargin}px;
          `
        : css`
            left: ${leftOffset}px;
          `}
      right: ${theme.metrics.baseMargin}px;
      margin-left: auto;
      margin-right: auto;
      max-width: ${theme.metrics.web.contentMaxWidth}px;
    `
  }}
  background-color: ${({ theme, variant }) => getBackgroundColor(theme, variant)};
  border-radius: ${({ theme }) => theme.metrics.borderRadius.small}px;
  padding: ${({ theme }) => theme.metrics.baseMargin}px;
  ${({ theme }) => theme.shadows.normal}
  z-index: 9999;
  ${({ isWeb }) => (isWeb ? 'cursor: pointer;' : '')}
`

export const ToastContent = styled.View<{ isWeb?: boolean }>`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: ${({ theme }) => theme.metrics.baseMargin / 2}px;
  ${({ isWeb }) => (isWeb ? 'width: 100%;' : '')}
`

export const ToastColumn = styled.View`
  flex: 1;
  flex-direction: column;
  align-items: flex-start;
`

export const ToastTitle = styled(Typography).attrs(() => ({
  variant: 'h4',
}))<{ isWeb?: boolean; toastVariant?: ToastVariant }>`
  color: ${({ theme, toastVariant }) => getTextColor(theme, toastVariant)};
  ${({ isWeb }) => (isWeb ? 'width: 100%; word-wrap: break-word; overflow-wrap: break-word;' : '')}
`

export const ToastDescription = styled(Typography).attrs(() => ({
  variant: 'bodySmall',
}))<{
  isWeb?: boolean
  toastVariant?: ToastVariant
}>`
  color: ${({ theme, toastVariant }) => getTextColor(theme, toastVariant)};
  margin-top: ${({ theme }) => theme.metrics.baseMargin / 2}px;
  ${({ isWeb }) => (isWeb ? 'word-wrap: break-word; overflow-wrap: break-word;' : '')}
`

export const ToastLink = styled(Typography).attrs(() => ({
  variant: 'bodyNormalBold',
}))<{ isWeb?: boolean; toastVariant?: ToastVariant }>`
  color: ${({ theme, toastVariant }) => getTextColor(theme, toastVariant)};
  text-decoration-line: underline;
  text-align: right;
  ${({ isWeb, theme }) =>
    isWeb
      ? `
    margin-left: ${theme.metrics.baseMargin}px;
    white-space: nowrap;
  `
      : ''}
`
